import styled from 'styled-components'

export const BrainzContainer = styled.div`
  color: #fff;
  background: #000;
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  height: 1050px;
  overflow-x: hidden;

  @media screen and (max-width: 850px) {
    height: 1600px;
  }
`
export const BrainzWrapper = styled.div`
  display: flex;
  z-index: 3;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
  align-items: center;
  position: absolute;
  padding-top: 90px;
  flex-direction: column;
`

export const BrainzBg = styled.img`
  background-repeat: no-repeat;
  width: 100%;
  overflow: hidden;
`

export const ImgWrap = styled.div`
  height: 100%;
  max-width: 800px;
  margin-bottom: 30px;
`

export const Img = styled.img`
  width: 100%;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 700px;
  margin-left: 35px;
  margin-right: 20px;
`

export const TextH1 = styled.h1`
  margin-bottom: 0;
  margin-top: 8px;
  font-size: 30px;
  line-height: 1.1;
  font-weight: 500;
  /* color: #DCE46C; */
  color: #F06C97;
`

export const TextP = styled.p`
  margin-bottom: 10px;
  font-size: 18px;
  line-height: 26px;
  color: #fff;
  text-align: justify;
  max-width: 500px;
`

export const InfoGraphicWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 850px) {
    flex-direction: column;
  }
`

export const ChartContainer = styled.div`
  margin-top: 15px;
  max-width: 500px;
`